const getSeoReducer = state => state.seo;

export default {
  seoFooter: store => getSeoReducer(store).seoFooter
};
